import React from "react";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody, TableCell, TableRow, TableHead } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { wifiDevice } from "./infoenum";
import { frequecyMHzToGHz } from "../../../../../common/utils"

const WiFiScannedAPs = props => (
  <Table className={props.classes.table}>
      <TableHead>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {"SSID"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first_wide}>
          {props.translate("channel_frequency_no_units")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("signal_strength")}
        </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
      {props.data.aps && props.data.aps.length > 0 && (
        props.data.aps.map((item, k) => {
          let ssid = item.ssid
          let bssid = "(BSSID: " + item.macaddr + ")"
          if (ssid === null || ssid.length <= 0) {
            ssid = "-"
          }
          if (item.channel === null || item.channel <= 0) {
            item.channel = "-"
          }
          let channelwidth = item.channelwidth
          if (channelwidth === null || channelwidth <= 0) {
            channelwidth = "-"
          }
          else {
            channelwidth += " MHz"
          }
          if (item.frequency === null || item.frequency <= 0) {
            item.frequency = "-"
          }
          else {
            item.frequency = frequecyMHzToGHz(item.frequency)
          }
          let frequency = item.frequency
          if (frequency != "-") {
              frequency += " GHz"
          }
          return (
            <TableRow key={k}>
              <TableCell className={props.classes.tablecontent_first}>
                {ssid}
                <Typography>{bssid}</Typography>
              </TableCell>
              <TableCell className={props.classes.tablecontent_first_wide}>
                {item.channel + " / " + frequency + " / " + channelwidth}
              </TableCell>
              <TableCell className={props.classes.tablecontent_first}>
                {item.signalstrengthdbm + "dBm (" + item.signalstrengthpercent + "%)"}
              </TableCell>
            </TableRow>
          );
        }))}
    </TableBody>
  </Table>
);
export default withStyles(styles)(WiFiScannedAPs);



// WEBPACK FOOTER //
// ./src/components/common/results/views/stats/wifiScannedAPs.js